import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Path from './Common/Path';
import HomeScreen from './Screens/Homes/HomeScreen';
import ContactScreen from './Screens/Contact/ContactScreen';
import Header from './Componant/Header';
import AboutScreen from './Screens/About/AboutScreen';
import NewsMediaScreen from './Screens/News & Media/NewsMediaScreen';
import Footer from './Componant/Footer';
import ProductScreen from './Screens/Products/ProductScreen';
import MaterialScreen from './Screens/Products/MaterialScreen';
import ScrollToTop from './Componant/ScrollToTop';

function App() {

  return (
    <BrowserRouter>
      <Header />
      <main style={{ paddingTop: "60px", minHeight: "calc(100vh - 25vh)" }}>
        <ScrollToTop />
        <Routes>
          <Route path={Path.home} element={<HomeScreen />} />
          <Route path={Path.contact} element={<ContactScreen />} />
          <Route path={Path.about} element={<AboutScreen />} />
          <Route path={Path.newsmedia} element={<NewsMediaScreen />} />


          <Route path={"/product/*"} element={<ProductScreen />} />
          <Route path="/material/:catergory" element={<MaterialScreen />} />


        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
